import {
  TeacherDeleteLiveClassGroupsMutationVariables,
  TeacherGetLiveClassGroupsQueryVariables,
  TeacherGetStudentsForGroupByGroupIdQueryVariables,
  TeacherTeacherInsertLiveClassGroupMutationVariables,
} from '@school_ify/schoolify-repository/src/teacher/types';
import {
  createGroup,
  deleteGroup,
  TeacherGetLiveClassGroups,
  getStudentsByGroupId,
} from '@school_ify/schoolify-repository/src/teacher/repositories/liveClassGroupsRepository';

export default class LiveClassGroups {
  async createLiveClassGroup(variables: TeacherTeacherInsertLiveClassGroupMutationVariables) {
    const createdGroup = await createGroup(variables);
    return createdGroup;
  }

  async getLiveClassGroups(variables: TeacherGetLiveClassGroupsQueryVariables) {
    const teacherGetsLiveClassGroups = await TeacherGetLiveClassGroups(variables);
    return teacherGetsLiveClassGroups;
  }

  async removeGroups(variables: TeacherDeleteLiveClassGroupsMutationVariables) {
    const deletedGroup = await deleteGroup(variables);
    return deletedGroup;
  }

  async getStudentsByGroupId(
    variables: TeacherGetStudentsForGroupByGroupIdQueryVariables
  ): Promise<Array<{ user_id: string }>> {
    const students = await getStudentsByGroupId(variables);
    return students;
  }
}
